export const nav = [
  {
    type: 'section',
    title: '',
    items: [{ type: 'link', title: 'Dashboard', name: 'dashboard', path: '/dashboard' }]
  },
  {
    type: 'section',
    title: 'Customer Management',
    has_horizontal_rule: true,
    items: [
      {
        type: 'link',
        title: 'Billing & Payments',
        name: 'payments',
        path: '/billings/modules'
      },
      {
        type: 'link',
        title: 'RevOps',
        name: 'analysis',
        path: '/revops/revenue',
        match: '/revops'
      },
      { type: 'link', title: 'Customers', name: 'groups', path: '/customers' },
      { type: 'link', title: 'Issues', name: 'warning', path: '/issues' }
    ]
  },
  {
    type: 'section',
    title: 'Customer Resources',
    has_horizontal_rule: true,
    items: [
      {
        type: 'link',
        title: 'Audiences',
        name: 'groups',
        path: '/audiences'
      },
      {
        type: 'link',
        title: 'Campaigns',
        name: 'campaign',
        path: '/campaigns'
      },
      {
        type: 'link',
        title: 'Transactional Email',
        name: 'transactional',
        path: '/transactionals'
      },
      {
        type: 'link',
        title: 'Messaging',
        name: 'send',
        path: '/messaging/sms',
        match: '/messaging'
      }
    ]
  },
  {
    type: 'section',
    title: 'Content',
    has_horizontal_rule: true,
    items: [
      { type: 'link', title: 'Content', name: 'blogs', path: '/content/blogs', match: '/content' },
      { type: 'link', title: 'Announcements', name: 'notifications', path: '/announcements' }
    ]
  },
  {
    type: 'section',
    title: 'Config',
    has_horizontal_rule: true,
    items: [
      {
        type: 'link',
        title: 'User Management',
        name: 'profile',
        path: '/user-management/users'
      },
      {
        type: 'link',
        title: 'Servers',
        name: 'server',
        path: '/servers'
      },
      { type: 'link', title: 'Tutorial', name: 'book', path: '/tutorials' }
    ]
  }
];
